/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';


import moment from 'moment';
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";



am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const TypeComplaintPieChart = (props) => {

    const { sBA, data } = props

    useEffect(() => {

        if (data && data.length > 0) {
            (data || []).forEach((element, ind) => {
                onRenderGraphPieGauge(element.lstdata , element.sTitle,element.sId, ind);
            });
        }
    }, [data])


    const onRenderGraphPieGauge = (data, sTitle, sId, ind) => {



        // Create chart instance
        var chart = am4core.create(`gauge_${ind}`, am4charts.RadarChart) as any;
        chart.zoomOutButton.disabled = true;
        chart.colors.list = [
            am4core.color("#f02e18"),
            am4core.color("#f0cc18"),
            am4core.color("#1836f0"),
        ];

        let title = chart.titles.create();
        title.text = sTitle;
        title.fontSize = 16;
        title.marginBottom = 10;

        // Add data
        chart.data = data;

        // Make chart not full circle
        chart.startAngle = -90;
        chart.endAngle = 220;
        chart.innerRadius = am4core.percent(50);

        // Set number format
        chart.numberFormatter.numberFormat = "#.#'%'";

        // Create axes
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.grid.template.strokeOpacity = 0;
        categoryAxis.renderer.labels.template.visible = false;

        var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.grid.template.strokeOpacity = 0;
        valueAxis.renderer.labels.template.visible = false;
        valueAxis.min = 0;

        // Create series
        var series1 = chart.series.push(new am4charts.RadarColumnSeries());
        series1.dataFields.valueX = "full";
        series1.dataFields.categoryY = "category";
        series1.clustered = false;
        series1.columns.template.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
        series1.columns.template.fillOpacity = 0.08;
        series1.columns.template.cornerRadiusTopLeft = 20;
        series1.columns.template.strokeWidth = 0;
        series1.columns.template.radarColumn.cornerRadius = 20;

        var series2 = chart.series.push(new am4charts.RadarColumnSeries());
        series2.dataFields.valueX = "value";
        series2.dataFields.categoryY = "category";

        series2.clustered = false;
        series2.columns.template.strokeWidth = 0;
        series2.columns.template.tooltipText = "{category}: [bold]{value}[/]";
        series2.columns.template.radarColumn.cornerRadius = 20;

        series2.columns.template.adapter.add("fill", function (fill, target) {
            return chart.colors.getIndex(target.dataItem.index);
        });

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: 10 + ind,
                    sDesc: sId,
                    sName: ind == 0 ? "ข้อร้องเรียนที่มีนัยสำคัญ" : ind == 1 ? "ข้อร้องขอ" : ind == 2 ? "ข้อร้องเรียนปกติ" : "ทั้งหมด",
                    idDiv: 2,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);

    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                {
                    data.length > 0 ?
                        data.map((element, index) => {
                            let id1 = element.lstdata.filter(f => f.nId == 1).length > 0 ? element.lstdata.filter(f => f.nId == 1)[0] : 0
                            let id2 = element.lstdata.filter(f => f.nId == 2).length > 0 ? element.lstdata.filter(f => f.nId == 2)[0] : 0
                            let id3 = element.lstdata.filter(f => f.nId == 3).length > 0 ? element.lstdata.filter(f => f.nId == 3)[0] : 0
                            return (
                                <Fragment key={`ba-pie_Fragment_${index}`}>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                            {/* <Grid item xs={12} style={{ textAlign: 'center' }}>
                                                <Typography>{element.sTitle}</Typography>
                                            </Grid> */}
                                            <Grid item xs={12} md={7}>
                                                <div id={`gauge_${index}`} style={{ width: "100%", height: "200px" }}></div>
                                            </Grid>
                                            <Grid item xs={12} md={5}>
                                                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                                    <Grid item xs={12}>
                                                        <div style={{ backgroundColor: '#1836f0', color: '#ffffff', padding: '5px', width: '50px', borderRadius: '10px', textAlign: 'center' }}>{id3.value}%</div>
                                                        <Typography style={{ fontSize: '14px' }}>{id3.category}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div style={{ backgroundColor: '#f0cc18', color: '#ffffff', padding: '5px', width: '50px', borderRadius: '10px', textAlign: 'center' }}>{id2.value}%</div>
                                                        <Typography style={{ fontSize: '14px' }}>{id2.category}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <div style={{ backgroundColor: '#f02e18', color: '#ffffff', padding: '5px', width: '50px', borderRadius: '10px', textAlign: 'center' }}>{id1.value}%</div>
                                                        <Typography style={{ fontSize: '14px' }}>{id1.category}</Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Fragment>
                            )
                        })
                        : null
                }
            </Grid>
        </>
    )
}

export default TypeComplaintPieChart